<template>
	<div class="step-wrapper">
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step1.firstMessage')"/>
		<div v-for="(topic, index) in stepTopics" :key="`topic-${index}`" class="step-topics">
            <span class="circle"/>
            {{topic}}
        </div>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step1.secondMessage')"/>
	</div>
</template>

<script setup>
/* Vue */
import { ref } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const stepTopics = ref([
    t('payments.batchfile.newPayment.helperModal.step1.topics.topic1'),
    t('payments.batchfile.newPayment.helperModal.step1.topics.topic2'),
    t('payments.batchfile.newPayment.helperModal.step1.topics.topic3'),
    t('payments.batchfile.newPayment.helperModal.step1.topics.topic4'),
    t('payments.batchfile.newPayment.helperModal.step1.topics.topic5')
])

</script>
<style lang="scss" scoped>
.step-wrapper {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    color: var(--secondary-dark-2);

    .step-message {
        width: 100%;

        @include H7-Regular;
        line-height: 16px;

        &:first-of-type {
            margin-bottom: 24px;
        }

        &:last-of-type {
            margin-top: 24px;
        }
    }

    .step-topics {
        width: 100%;

        display: flex;
        align-items: center;
        justify-content: flex-start;

        @include H7-Medium;
        line-height: 16px;

        .circle {
            width: 4px;
            height: 4px;
            margin-right: 8px;

            flex-shrink: 0;

            border-radius: 50%;
            background-color: var(--secondary-dark-2);
        }
    }
}

</style>
